import { VariableType } from "../VariableType";
import { BaseTypeSchema } from "../BaseTypeSchema";

export class TimeZoneSchema extends BaseTypeSchema
{
    constructor(required: boolean)
    {
        super(VariableType.TimeZone, required);
        this.setValid(
            "UTC -12:00 - Baker Island Time",
            "UTC -11:00 - Samoa Standard Time",
            "UTC -10:00 - Hawaii - Aleutian Time",
            "UTC -09:30 - Marquesas Time",
            "UTC -09:00 - Alaska Time",
            "UTC -08:00 - Pacific Time(USA & Canada)",
            "UTC -07:00 - Mountain Time(USA & Canada)",
            "UTC -06:00 - Central Time(USA & Canada)",
            "UTC -05:00 - Eastern Time(USA & Canada)",
            "UTC -04:00 - Atlantic Time(Canada)",
            "UTC -03:30 - Newfoundland Time",
            "UTC -03:00 - Brasília Time",
            "UTC -02:00 - South Georgia Time",
            "UTC -01:00 - Azores Time",
            "UTC ±00:00 - Greenwich Mean Time(GMT)",
            "UTC +01:00 - Central European Time",
            "UTC +02:00 - Eastern European Time",
            "UTC +03:00 - Moscow Time",
            "UTC +03:30 - Iran Standard Time",
            "UTC +04:00 - Gulf Standard Time",
            "UTC +04:30 - Afghanistan Time",
            "UTC +05:00 - Pakistan Standard Time",
            "UTC +05:30 - Indian Standard Time",
            "UTC +05:45 - Nepal Time",
            "UTC +06:00 - Bangladesh Standard Time",
            "UTC +06:30 - Myanmar Time",
            "UTC +07:00 - Indochina Time",
            "UTC +08:00 - China Standard Time",
            "UTC +08:45 - Australian Central Western Time",
            "UTC +09:00 - Japan Standard Time",
            "UTC +09:30 - Australian Central Time",
            "UTC +10:00 - Australian Eastern Time",
            "UTC +10:30 - Lord Howe Island Time",
            "UTC +11:00 - Solomon Islands Time",
            "UTC +12:00 - New Zealand Standard Time",
            "UTC +12:45 - Chatham Islands Time",
            "UTC +13:00 - Tonga Time",
            "UTC +14:00 - Line Islands Time",
        );
    }
}